module.exports = __webpack_public_path__ + "img/woyaoyou_head_defult@2x.573baf08.png";